<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("TITLES.editClient") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #008274">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <ValidationObserver v-slot="{ invalid }">
        <form @submit.prevent="validateFormInputs">
          <div class="row">
            <!-- ✅ Image Upload with validation -->
            <ValidationProvider
              name="الصورة"
              rules="required"
              v-slot="{ errors }"
              class="col-12"
            >
              <base-image-upload-input
                col="12"
                identifier="admin_image"
                :preSelectedImage="data.image.path"
                :placeholder="$t('PLACEHOLDERS.personalImage')"
                @selectImage="selectImage"
                :errors="errors[0]"
              />
            </ValidationProvider>

            <!-- ✅ Name Input -->
            <ValidationProvider
              :name="$t('PLACEHOLDERS.name')"
              rules="required"
              v-slot="{ errors }"
              class="col-6"
            >
              <base-input
                col="12"
                type="text"
                :placeholder="$t('PLACEHOLDERS.name')"
                v-model="data.name"
                :errors="errors[0] || nameServerError"
                @input="nameServerError = null"
                required
              />
            </ValidationProvider>

            <!-- ✅ Email Input -->
            <ValidationProvider
              :name="$t('PLACEHOLDERS.email')"
              rules="email"
              v-slot="{ errors }"
              class="col-6"
            >
              <base-input
                col="12"
                type="text"
                :placeholder="$t('PLACEHOLDERS.email')"
                v-model.trim="data.email"
                :errors="errors[0] || emailServerError"
                @input="emailServerError = null"
              />
            </ValidationProvider>

            <!-- ✅ Phone Input -->
            <ValidationProvider
              :name="$t('PLACEHOLDERS.phone')"
              rules="required|phone"
              v-slot="{ errors }"
              class="col-12"
            >
              <base-input
                col="12"
                type="number"
                :placeholder="$t('PLACEHOLDERS.phone')"
                v-model.trim="data.phone"
                @input="mobileServerError = null"
                :errors="errors[0] || mobileServerError"
                required
              />
            </ValidationProvider>
            <ValidationProvider
              :name="$t('PLACEHOLDERS.whatsapp')"
              rules="required|phone"
              v-slot="{ errors }"
              class="col-12"
            >
              <base-input
                col="12"
                type="number"
                :placeholder="$t('PLACEHOLDERS.whatsapp')"
                v-model.trim="data.whatsapp"
                @input="mobileServerError = null"
                :errors="errors[0] || mobileServerError"
                required
              />
            </ValidationProvider>
            <!-- ✅ Activate Edit Password Switch -->
            <div class="input_wrapper switch_wrapper my-5 col-12">
              <v-switch
                color="green"
                :label="$t('PLACEHOLDERS.editPassword')"
                v-model="data.enableEditPassword"
                hide-details
              ></v-switch>
            </div>

            <!-- ✅ Password fields (conditionally rendered and validated) -->
            <Transition name="fadeInUp" mode="out-in">
              <div class="col-12" v-if="data.enableEditPassword">
                <div class="row">
                  <!-- Password -->
                  <ValidationProvider
                    :name="$t('PLACEHOLDERS.password')"
                    rules="required|custom_password"
                    v-slot="{ errors }"
                    class="col-6"
                  >
                    <base-input
                      col="12"
                      type="password"
                      :placeholder="$t('PLACEHOLDERS.password')"
                      v-model.trim="data.password"
                      :errors="errors[0]"
                      required
                    />
                  </ValidationProvider>

                  <!-- Confirm Password -->
                  <ValidationProvider
                    :name="$t('PLACEHOLDERS.confirmPassword')"
                    :rules="{
                      required: data.enableEditPassword,
                      password_match: { target: data.password },
                    }"
                    v-slot="{ errors }"
                    class="col-6"
                  >
                    <base-input
                      col="12"
                      type="password"
                      :placeholder="$t('PLACEHOLDERS.confirmPassword')"
                      v-model.trim="data.passwordConfirmation"
                      :errors="errors[0]"
                      required
                    />
                  </ValidationProvider>
                </div>
              </div>
            </Transition>

            <!-- ✅ Submit Button -->
            <div class="btn_wrapper col-12 text-end">
              <base-button
                class="mt-2"
                styleType="primary_btn"
                :btnText="$t('BUTTONS.save')"
                :isLoading="isWaitingRequest"
                :disabled="invalid || isWaitingRequest"
              />
            </div>
          </div>
        </form>
      </ValidationObserver>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "EditAdmin",

  props: {
    id: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data

      // Start:: Data Collection To Send
      data: {
        image: {
          path: null,
          file: null,
        },
        name: null,
        email: null,
        phone: null,
        role: null,
        whatsApp: null,
        areas: null,
        type: null,
        enableEditPassword: false,
        password: null,
        passwordConfirmation: null,
        active: true,
        whatsapp: null,
      },
      allAreas: [],
      roles: [],
      emailServerError: null,
      mobileServerError: null,
      nameServerError: null,
      // End:: Data Collection To Send
    };
  },

  computed: {
    // Start:: Vuex Getters
    ...mapGetters({
      allRoles: "ApiGetsModule/allRoles",
    }),
    // End:: Vuex Getters
  },

  methods: {
    async getRoles() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: "roles?page=0&limit=0&status=1",
        });
        this.roles = res.data.data;
      } catch (error) {
        this.loading = false;
        console.log(error.response.data.message);
      }
    },
    // Start:: Get Data To Show
    async getDataToEdit() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `users/${this.id}`,
        });
        this.data.image.path = res.data.data.User?.image;
        this.data.name = res.data.data.User?.name;
        this.data.email = res.data.data.User?.email;
        this.data.phone = res.data.data.User?.mobile;
        this.data.whatsapp = res.data.data.User?.whatsapp;

        this.data.role = res.data.data.User?.role_obj;
        this.data.active = res.data.data.User?.is_active;
        this.data.numberOfVisits = res.data.data.User?.login_count;
        this.data.lastVisit = res.data.data.User?.last_login;
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
    // End:: Get Data To Show

    // Start:: Select Upload Image
    selectImage(selectedImage) {
      this.data.image = selectedImage;
    },
    // End:: Select Upload Image

    // Start:: validate Form Inputs
    validateFormInputs() {
      this.isWaitingRequest = true;

      // if (!this.data.image.path) {
      //   this.isWaitingRequest = false;
      //   this.$message.error(this.$t("VALIDATION.image"));
      //   return;
      // }
      if (!this.data.name) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.name"));
        return;
      } else if (!this.data.phone) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.mobileNumber"));
        return;
      }
      // else if (!this.data.role) {
      //   this.isWaitingRequest = false;
      //   this.$message.error(this.$t("VALIDATION.role"));
      //   return;
      // }
      else if (this.data.enableEditPassword) {
        if (!this.data.password) {
          this.isWaitingRequest = false;
          this.$message.error(this.$t("VALIDATION.password"));
          return;
        } else if (this.data.password.length < 8) {
          this.isWaitingRequest = false;
          this.$message.error(this.$t("VALIDATION.passwordLength"));
          return;
        } else if (!this.data.passwordConfirmation) {
          this.isWaitingRequest = false;
          this.$message.error(this.$t("VALIDATION.password"));
          return;
        } else if (this.data.passwordConfirmation.length < 8) {
          this.isWaitingRequest = false;
          this.$message.error(this.$t("VALIDATION.passwordLength"));
          return;
        } else if (this.data.password != this.data.passwordConfirmation) {
          this.isWaitingRequest = false;
          this.$message.error(this.$t("VALIDATION.notEqualPasswords"));
          return;
        } else {
          this.submitForm();
        }
      } else {
        this.submitForm();
        return;
      }
    },
    // End:: validate Form Inputs
    setServerError(field, error) {
      this[`${field}ServerError`] =
        error?.response?.data?.errors?.[field]?.[0] || null;
    },
    // Start:: Submit Form
    async submitForm() {
      const REQUEST_DATA = new FormData();
      // Start:: Append Request Data
      REQUEST_DATA.append("_method", "PUT");

      if (this.data.image.file != null) {
        REQUEST_DATA.append("avatar", this.data.image?.file);
      }
      REQUEST_DATA.append("name", this.data.name);
      if (this.data.email) REQUEST_DATA.append("email", this.data.email);
      REQUEST_DATA.append("mobile", this.data.phone);
      REQUEST_DATA.append("whatsapp", this.data.whatsapp);


      REQUEST_DATA.append("role", 2);
      if (this.data.password) {
        REQUEST_DATA.append("password", this.data.password);
      }

      if (this.data.passwordConfirmation) {
        REQUEST_DATA.append(
          "password_confirmation",
          this.data.passwordConfirmation
        );
      }
      REQUEST_DATA.append("is_active", this.data.active ? 1 : 0);
      // Start:: Append Request Data

      try {
        await this.$axios({
          method: "POST",
          url: `users/${this.id}`,
          data: REQUEST_DATA,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.editedSuccessfully"));
        this.$router.push({ path: "/clients/all" });
      } catch (error) {
        this.isWaitingRequest = false;
        this.setServerError("email", error);
        this.setServerError("mobile", error);
        this.setServerError("name", error);
        this.$message.error(error.response.data.message);
      }
    },
    // End:: Submit Form
  },

  async created() {
    // Start:: Fire Methods
    this.getRoles();
    this.getDataToEdit();
    // End:: Fire Methods
  },
};
</script>
